import { useGetAssessmentQuery } from "../assessmentsSlice";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useAssessment = ({ id }) => {
  const organisationId = useOrganisationId();

  const hasAccessToAssessmentForOrganisation = useHasAccess({
    apiCall: "organisations.id.assessments.id.GET",
    organisation: organisationId,
  });
  const assessmentForOrganisation = useGetAssessmentQuery(
    { organisationId, assessmentId: id },
    {
      skip:
        id == null ||
        organisationId == null ||
        !hasAccessToAssessmentForOrganisation,
    }
  );

  const hasAccessToAssessment = useHasAccess({
    apiCall: "assessments.id.GET",
  });
  const assessment = useGetAssessmentQuery(
    { assessmentId: id },
    { skip: id == null || organisationId != null || !hasAccessToAssessment }
  );
  useRefresher(assessment);

  if (organisationId != null) {
    return {
      ...assessmentForOrganisation,
      hasAccess: hasAccessToAssessmentForOrganisation,
    };
  }
  return { ...assessment, hasAccess: hasAccessToAssessment };
};

export default useAssessment;
